import { GET_PAYMENTS } from "constants/payments";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PAYMENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
